import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { checkIfURLContainsSearchParam } from '@wsc/utils/urlHelpers';
import {
	setRoomObjectById,
	selectInSceneTextRoomObjects,
} from '@wsc/redux_stores/roomObjectsReducer';
import { selectAllHotspotsLoaded } from '@wsc/redux_stores/sceneLoadReducer';

/**
 * @module InSceneTextController
 *
 * @description
 * Module to set the text of room objects based on the URL search params.
 *
 * ## Uses
 * - Uses [`checkIfURLContainsSearchParam`]{@link module:urlHelpers~checkIfURLContainsSearchParam} to check if the URL contains a search param.
 * - Uses [`setRoomObjectById`]{@link module:roomObjectsReducer~setRoomObjectById} to set the text of the room object.
 * - Uses [`selectAllHotspotsLoaded`]{@link module:sceneLoadReducer~selectAllHotspotsLoaded} to check if all hotspots are loaded.
 * - Uses [`selectInSceneTextRoomObjects`]{@link module:roomObjectsReducer~selectInSceneTextRoomObjects} to get all room objects with in-scene text.
 *
 * ### Functionality
 * - Once all hotspots are loaded, the module checks if the URL contains a search param that is in a text room object.
 * - If the URL contains the search param, the text of the room object is set to the value of the search param.
 *
 */
const InSceneTextController = () => {
	const inSceneTextRoomObjects = useSelector(selectInSceneTextRoomObjects);
	const allHotspotsLoaded = useSelector(selectAllHotspotsLoaded);
	const dispatch = useDispatch();

	useEffect(() => {
		if (!allHotspotsLoaded) return;

		inSceneTextRoomObjects.forEach((roomObject) => {
			const inSceneText =
				checkIfURLContainsSearchParam(
					roomObject.props?.data?.urlSearchParam,
				) || '';

			dispatch(
				setRoomObjectById({
					id: roomObject._id.$oid,
					...roomObject,
					props: {
						...roomObject.props,
						data: {
							...roomObject.props.data,
							text: inSceneText,
						},
					},
				}),
			);
		});
	}, [allHotspotsLoaded]);

	return <></>;
};

export default InSceneTextController;
